module.exports = __webpack_public_path__ + "img/about_fcg.b94b5ffc.png";